import "simplebar/src/simplebar.css";
import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { ContentSettingState } from "./Hooks/ContentSettingState";

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <ContentSettingState>
        <App />
      </ContentSettingState>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById("root"),
);

serviceWorker.unregister();

reportWebVitals();
